import { matchPath } from 'react-router-dom';
import { routes } from 'routes/route-paths';
import { StepNumber } from 'types/stepper/stepper.type';
import { GoToStepProps } from 'types/stepper/stepper.type';

export const proposalStepToRoute = (step: GoToStepProps['step']) => {
  switch (step) {
    case 1:
      return routes.proposalsRoutes.editRoutes.clientDetails;
    case 2:
      return routes.proposalsRoutes.editRoutes.productSelection;
    case 3:
      return routes.proposalsRoutes.editRoutes.investmentDetails;
    case 4:
      return routes.proposalsRoutes.editRoutes.proposalSummary;
    case 5:
      return routes.proposalsRoutes.editRoutes.application;
    case 6:
      return routes.proposalsRoutes.editRoutes.signing;
    default:
      return routes.proposalsRoutes.editRoutes.clientDetails;
  }
};

export const proposalRouteToStep = (pathName: string): StepNumber | undefined => {
  if (matchPath(routes.proposalsRoutes.editRoutes.clientDetails, pathName)) {
    return 1;
  }
  if (matchPath(routes.proposalsRoutes.editRoutes.productSelection, pathName)) {
    return 2;
  }
  if (matchPath(routes.proposalsRoutes.editRoutes.investmentDetails, pathName)) {
    return 3;
  }
  if (matchPath(routes.proposalsRoutes.editRoutes.proposalSummary, pathName)) {
    return 4;
  }
  if (matchPath(routes.proposalsRoutes.editRoutes.application, pathName)) {
    return 5;
  }
  if (matchPath(routes.proposalsRoutes.editRoutes.signing, pathName)) {
    return 6;
  }

  return;
};
